import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from '@guildeducationinc/recess/icons/AddIcon';
import DeleteIcon from '@guildeducationinc/recess/icons/DeleteOutlineIcon';
import classNames from 'classnames';
import { useContext, useEffect } from 'react';
import { useLocale } from '../../hooks';
import { FilterGroupOperator } from '../../types';
import { DropdownSelect } from '../DropdownSelect';
import { EnumPicker } from '../EnumPicker';
import { TrackableButton } from '../TrackableButton';
import { FilterBuilderContext } from './FilterBuilder';
import { FilterConditionRow } from './FilterConditionRow';
import styles from './FilterGroupRow.module.scss';
export const FilterGroupRow = (props) => {
    const { t } = useLocale();
    const filterBuilderProps = useContext(FilterBuilderContext);
    useEffect(() => {
        if (filterBuilderProps.initialCondition &&
            props.group.conditions.length === 0 &&
            props.group.groups.length === 0) {
            createCondition();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOpChange = (value) => {
        props.onChange({ ...props.group, op: value });
    };
    const createCondition = () => {
        props.onChange({
            ...props.group,
            conditions: [
                ...(props.group.conditions ?? []),
                {
                    entityType: filterBuilderProps.defaultEntityType ?? '',
                    fieldCode: '',
                    op: '',
                    values: [],
                    message: {
                        success: {},
                        failure: {},
                    },
                },
            ],
        });
    };
    const createGroup = () => {
        props.onChange({
            ...props.group,
            groups: [
                ...(props.group.groups ?? []),
                {
                    op: FilterGroupOperator.AND,
                    conditions: [],
                    groups: [],
                },
            ],
        });
    };
    const handleGroupChange = (item, index) => {
        const groups = [...(props.group.groups ?? [])];
        groups[index] = item;
        props.onChange({ ...props.group, groups });
    };
    const handleConditionChange = (item, index) => {
        const conditions = [...(props.group.conditions ?? [])];
        conditions[index] = item;
        props.onChange({ ...props.group, conditions });
    };
    const handleGroupDelete = (index) => {
        const groups = [...(props.group.groups ?? [])];
        groups.splice(index, 1);
        props.onChange({ ...props.group, groups });
    };
    const handleConditionDelete = (index) => {
        const conditions = [...(props.group.conditions ?? [])];
        conditions.splice(index, 1);
        props.onChange({ ...props.group, conditions });
    };
    return (_jsx("div", { className: classNames(styles.filterGroup, props.readonly && styles.readonly), children: _jsxs("div", { className: 'flex flex-col gap-3 p-3', children: [_jsxs("div", { className: 'flex gap-1 items-center', children: [_jsx("div", { className: 'text-sm mr-5', children: "Group" }), props.group.conditions.length + props.group.groups.length > 1 && (_jsx(EnumPicker, { className: 'grow', labelPrefix: 'filter.group.operator', placeholderKey: 'filter.select.group_operator', value: props.group.op, onChange: handleOpChange, enumType: FilterGroupOperator, disabled: props.readonly, useMui: true })), props.level > 1 && !props.readonly && (_jsx(TrackableButton, { btnType: 'icon', enText: 'Delete', tag: `filter_group_${props.group.op}`, label: t('Delete'), appearance: 'minimal', icon: _jsx(DeleteIcon, { size: 30 }), onClick: props.onDelete }))] }), props.group.conditions && props.group.conditions.length > 0 && (_jsx("div", { className: 'flex flex-col gap-3', style: { marginLeft: `${props.level * 15}px` }, children: props.group.conditions.map((condition, index) => {
                        return (_jsx(FilterConditionRow, { condition: condition, onChange: item => handleConditionChange(item, index), onDelete: () => handleConditionDelete(index), readonly: props.readonly, customizedMessaging: props.customizedMessaging }, `${condition.fieldCode}-${index}`));
                    }) })), props.group.groups && props.group.groups.length > 0 && (_jsx("div", { className: 'flex flex-col gap-3', style: { marginLeft: `${props.level * 15}px` }, children: props.group.groups.map((group, index) => {
                        return (_jsx(FilterGroupRow, { level: props.level + 1, group: group, onChange: item => handleGroupChange(item, index), onDelete: () => handleGroupDelete(index), readonly: props.readonly }, index));
                    }) })), !props.readonly && (_jsx("div", { style: { marginLeft: `${props.level * 15}px` }, children: _jsx(DropdownSelect, { options: [
                            { label: t('New Condition'), value: 'condition' },
                            { label: t('New Group'), value: 'group' },
                        ], label: _jsxs(_Fragment, { children: [_jsx(AddIcon, { size: 20, className: 'mr-2' }), " Add"] }), onChange: e => (e.target.value === 'condition' ? createCondition() : createGroup()) }) }))] }) }));
};
